'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StarIcon = exports.FacebookIcon = exports.TwitterIcon = exports.InstagramIcon = exports.ShopIcon = exports.CalenderIcon = exports.FlameIcon = exports.WarningIcon = exports.EditIcon = exports.LocationIcon = exports.JobIcon = exports.PeopleIcon = exports.PaletteIcon = exports.SearchIcon = exports.PlusIcon = exports.FingerprintIcon = exports.ClockIcon = exports.FaceIcon = exports.PersonIcon = exports.PhoneIcon = exports.EmailIcon = exports.PasswordIcon = exports.ReadMoreIcon = exports.DashboardIcon = exports.Cog = exports.Tick = exports.Cross = exports.SwapHorizontle = exports.RightArrow = exports.LeftArrow = exports.UpChevron = exports.DownChevron = exports.LeftChevron = exports.RightChevron = exports.Hamburger = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _templateObject = _taggedTemplateLiteral(['\n    path, circle {\n        opacity: ', ';\n        fill: ', ';\n    }\n'], ['\n    path, circle {\n        opacity: ', ';\n        fill: ', ';\n    }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var SVG = _styledComponents2.default.svg(_templateObject, function (_ref) {
  var faint = _ref.faint;
  return faint && '.5';
}, function (_ref2) {
  var theme = _ref2.theme,
      type = _ref2.type;
  return type ? theme.stateColors[type] : theme.brandColor;
});

var Hamburger = exports.Hamburger = function Hamburger(props) {
  return _react2.default.createElement(SVG, _extends({}, props, {
    className: 'icon',
    xmlns: 'http://www.w3.org/2000/svg',
    height: '24',
    viewBox: '0 0 24 24',
    width: '24'
  }), _react2.default.createElement('path', {
    d: 'M4 18h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zm0-5h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zM3 7c0 .55.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1z'
  }));
};

var RightChevron = exports.RightChevron = function RightChevron(props) {
  return _react2.default.createElement(SVG, _extends({}, props, {
    className: 'icon',
    xmlns: 'http://www.w3.org/2000/svg',
    height: '24',
    viewBox: '0 0 24 24',
    width: '24'
  }), _react2.default.createElement('path', {
    d: 'M9.29 6.71c-.39.39-.39 1.02 0 1.41L13.17 12l-3.88 3.88c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0l4.59-4.59c.39-.39.39-1.02 0-1.41L10.7 6.7c-.38-.38-1.02-.38-1.41.01z'
  }));
};

var LeftChevron = exports.LeftChevron = function LeftChevron(props) {
  return _react2.default.createElement(SVG, _extends({}, props, {
    className: 'icon',
    xmlns: 'http://www.w3.org/2000/svg',
    height: '24',
    viewBox: '0 0 24 24',
    width: '24'
  }), _react2.default.createElement('path', {
    d: 'M14.71 6.71c-.39-.39-1.02-.39-1.41 0L8.71 11.3c-.39.39-.39 1.02 0 1.41l4.59 4.59c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L10.83 12l3.88-3.88c.39-.39.38-1.03 0-1.41z'
  }));
};

var DownChevron = exports.DownChevron = function DownChevron(props) {
  return _react2.default.createElement(SVG, _extends({}, props, {
    className: 'icon',
    xmlns: 'http://www.w3.org/2000/svg',
    height: '24',
    viewBox: '0 0 24 24',
    width: '24'
  }), _react2.default.createElement('path', {
    d: 'M15.88 9.29L12 13.17 8.12 9.29c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41l4.59 4.59c.39.39 1.02.39 1.41 0l4.59-4.59c.39-.39.39-1.02 0-1.41-.39-.38-1.03-.39-1.42 0z'
  }));
};

var UpChevron = exports.UpChevron = function UpChevron(props) {
  return _react2.default.createElement(SVG, _extends({}, props, {
    className: 'icon',
    xmlns: 'http://www.w3.org/2000/svg',
    height: '24',
    viewBox: '0 0 24 24',
    width: '24'
  }), _react2.default.createElement('path', {
    d: 'M11.29 8.71L6.7 13.3c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 10.83l3.88 3.88c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L12.7 8.71c-.38-.39-1.02-.39-1.41 0z'
  }));
};

var LeftArrow = exports.LeftArrow = function LeftArrow(props) {
  return _react2.default.createElement(SVG, _extends({}, props, {
    className: 'icon',
    xmlns: 'http://www.w3.org/2000/svg',
    height: '24',
    viewBox: '0 0 24 24',
    width: '24'
  }), _react2.default.createElement('path', {
    d: 'M14.71 15.88L10.83 12l3.88-3.88c.39-.39.39-1.02 0-1.41-.39-.39-1.02-.39-1.41 0L8.71 11.3c-.39.39-.39 1.02 0 1.41l4.59 4.59c.39.39 1.02.39 1.41 0 .38-.39.39-1.03 0-1.42z'
  }));
};

var RightArrow = exports.RightArrow = function RightArrow(props) {
  return _react2.default.createElement(SVG, _extends({}, props, {
    className: 'icon',
    xmlns: 'http://www.w3.org/2000/svg',
    height: '24',
    viewBox: '0 0 24 24',
    width: '24'
  }), _react2.default.createElement('path', {
    d: 'M11.71 15.29l2.59-2.59c.39-.39.39-1.02 0-1.41L11.71 8.7c-.63-.62-1.71-.18-1.71.71v5.17c0 .9 1.08 1.34 1.71.71z'
  }));
};

var SwapHorizontle = exports.SwapHorizontle = function SwapHorizontle(props) {
  return _react2.default.createElement(SVG, _extends({}, props, {
    className: 'icon',
    xmlns: 'http://www.w3.org/2000/svg',
    height: '24',
    viewBox: '0 0 24 24',
    width: '24'
  }), _react2.default.createElement('path', {
    d: 'M6.14 11.86l-2.78 2.79c-.19.2-.19.51 0 .71l2.78 2.79c.31.32.85.09.85-.35V16H13c.55 0 1-.45 1-1s-.45-1-1-1H6.99v-1.79c0-.45-.54-.67-.85-.35zm14.51-3.21l-2.78-2.79c-.31-.32-.85-.09-.85.35V8H11c-.55 0-1 .45-1 1s.45 1 1 1h6.01v1.79c0 .45.54.67.85.35l2.78-2.79c.2-.19.2-.51.01-.7z'
  }));
};

var Cross = exports.Cross = function Cross(props) {
  return _react2.default.createElement(SVG, _extends({}, props, {
    className: 'icon',
    xmlns: 'http://www.w3.org/2000/svg',
    height: '24',
    viewBox: '0 0 24 24',
    width: '24'
  }), _react2.default.createElement('path', {
    d: 'M18.3 5.71c-.39-.39-1.02-.39-1.41 0L12 10.59 7.11 5.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z'
  }));
};

var Tick = exports.Tick = function Tick(props) {
  return _react2.default.createElement(SVG, _extends({
    className: 'icon'
  }, props, {
    xmlns: 'http://www.w3.org/2000/svg',
    height: '24',
    viewBox: '0 0 24 24',
    width: '24'
  }), _react2.default.createElement('path', {
    d: 'M9 16.17L5.53 12.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41l4.18 4.18c.39.39 1.02.39 1.41 0L20.29 7.71c.39-.39.39-1.02 0-1.41-.39-.39-1.02-.39-1.41 0L9 16.17z'
  }));
};

var Cog = exports.Cog = function Cog(props) {
  return _react2.default.createElement(SVG, _extends({}, props, {
    className: 'icon',
    xmlns: 'http://www.w3.org/2000/svg',
    height: '24',
    viewBox: '0 0 24 24',
    width: '24'
  }), _react2.default.createElement('path', {
    d: 'M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z'
  }));
};

var DashboardIcon = exports.DashboardIcon = function DashboardIcon(props) {
  return _react2.default.createElement(SVG, _extends({}, props, {
    className: 'icon',
    xmlns: 'http://www.w3.org/2000/svg',
    height: '24',
    viewBox: '0 0 24 24',
    width: '24'
  }), _react2.default.createElement('path', {
    d: 'M4 13h6c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1zm0 8h6c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm10 0h6c.55 0 1-.45 1-1v-8c0-.55-.45-1-1-1h-6c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1zM13 4v4c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1h-6c-.55 0-1 .45-1 1z'
  }));
};

var ReadMoreIcon = exports.ReadMoreIcon = function ReadMoreIcon(props) {
  return _react2.default.createElement(SVG, _extends({}, props, {
    className: 'icon',
    xmlns: 'http://www.w3.org/2000/svg',
    'enable-background': 'new 0 0 24 24',
    height: '24',
    viewBox: '0 0 24 24',
    width: '24'
  }), _react2.default.createElement('g', null, _react2.default.createElement('rect', {
    fill: 'none',
    height: '24',
    width: '24'
  }), _react2.default.createElement('rect', {
    fill: 'none',
    height: '24',
    width: '24'
  })), _react2.default.createElement('g', null, _react2.default.createElement('g', null, _react2.default.createElement('path', {
    d: 'M14,9h7c0.55,0,1-0.45,1-1c0-0.55-0.45-1-1-1h-7c-0.55,0-1,0.45-1,1C13,8.55,13.45,9,14,9z'
  }), _react2.default.createElement('path', {
    d: 'M21,15h-7c-0.55,0-1,0.45-1,1c0,0.55,0.45,1,1,1h7c0.55,0,1-0.45,1-1C22,15.45,21.55,15,21,15z'
  }), _react2.default.createElement('path', {
    d: 'M21,11h-4c-0.55,0-1,0.45-1,1c0,0.55,0.45,1,1,1h4c0.55,0,1-0.45,1-1C22,11.45,21.55,11,21,11z'
  }), _react2.default.createElement('path', {
    d: 'M8.85,7.85C8.54,7.54,8,7.76,8,8.21V11H3c-0.55,0-1,0.45-1,1c0,0.55,0.45,1,1,1h5v2.79c0,0.45,0.54,0.67,0.85,0.35 l3.79-3.79c0.2-0.2,0.2-0.51,0-0.71L8.85,7.85z'
  }))));
};

var PasswordIcon = exports.PasswordIcon = function PasswordIcon(props) {
  return _react2.default.createElement(SVG, _extends({}, props, {
    xmlns: 'http://www.w3.org/2000/svg',
    height: '24',
    viewBox: '0 0 24 24',
    width: '24'
  }), _react2.default.createElement('path', {
    d: 'M12.65 10C11.7 7.31 8.9 5.5 5.77 6.12c-2.29.46-4.15 2.29-4.63 4.58C.32 14.57 3.26 18 7 18c2.61 0 4.83-1.67 5.65-4H17v2c0 1.1.9 2 2 2s2-.9 2-2v-2c1.1 0 2-.9 2-2s-.9-2-2-2h-8.35zM7 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z'
  }));
};

var EmailIcon = exports.EmailIcon = function EmailIcon(props) {
  return _react2.default.createElement(SVG, _extends({}, props, {
    className: 'icon',
    xmlns: 'http://www.w3.org/2000/svg',
    height: '24',
    viewBox: '0 0 24 24',
    width: '24'
  }), _react2.default.createElement('path', {
    d: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-.4 4.25l-7.07 4.42c-.32.2-.74.2-1.06 0L4.4 8.25c-.25-.16-.4-.43-.4-.72 0-.67.73-1.07 1.3-.72L12 11l6.7-4.19c.57-.35 1.3.05 1.3.72 0 .29-.15.56-.4.72z'
  }));
};

var PhoneIcon = exports.PhoneIcon = function PhoneIcon(props) {
  return _react2.default.createElement(SVG, _extends({}, props, {
    className: 'icon',
    xmlns: 'http://www.w3.org/2000/svg',
    height: '24',
    viewBox: '0 0 24 24',
    width: '24'
  }), _react2.default.createElement('path', {
    d: 'M19.23 15.26l-2.54-.29c-.61-.07-1.21.14-1.64.57l-1.84 1.84c-2.83-1.44-5.15-3.75-6.59-6.59l1.85-1.85c.43-.43.64-1.03.57-1.64l-.29-2.52c-.12-1.01-.97-1.77-1.99-1.77H5.03c-1.13 0-2.07.94-2 2.07.53 8.54 7.36 15.36 15.89 15.89 1.13.07 2.07-.87 2.07-2v-1.73c.01-1.01-.75-1.86-1.76-1.98z'
  }));
};

var PersonIcon = exports.PersonIcon = function PersonIcon(props) {
  return _react2.default.createElement(SVG, _extends({}, props, {
    className: 'icon',
    xmlns: 'http://www.w3.org/2000/svg',
    height: '24',
    viewBox: '0 0 24 24',
    width: '24'
  }), _react2.default.createElement('path', {
    d: 'M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v1c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-1c0-2.66-5.33-4-8-4z'
  }));
};

var FaceIcon = exports.FaceIcon = function FaceIcon(props) {
  return _react2.default.createElement(SVG, _extends({}, props, {
    className: 'icon',
    xmlns: 'http://www.w3.org/2000/svg',
    height: '24',
    viewBox: '0 0 24 24',
    width: '24'
  }), _react2.default.createElement('path', {
    d: 'M9 11.75c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zm6 0c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8 0-.29.02-.58.05-.86 2.36-1.05 4.23-2.98 5.21-5.37C11.07 8.33 14.05 10 17.42 10c.78 0 1.53-.09 2.25-.26.21.71.33 1.47.33 2.26 0 4.41-3.59 8-8 8z'
  }));
};

var ClockIcon = exports.ClockIcon = function ClockIcon(props) {
  return _react2.default.createElement(SVG, _extends({}, props, {
    className: 'icon',
    xmlns: 'http://www.w3.org/2000/svg',
    height: '24',
    viewBox: '0 0 24 24',
    width: '24'
  }), _react2.default.createElement('path', {
    d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm-.22-13h-.06c-.4 0-.72.32-.72.72v4.72c0 .35.18.68.49.86l4.15 2.49c.34.2.78.1.98-.24.21-.34.1-.79-.25-.99l-3.87-2.3V7.72c0-.4-.32-.72-.72-.72z'
  }));
};

var FingerprintIcon = exports.FingerprintIcon = function FingerprintIcon(props) {
  return _react2.default.createElement(SVG, _extends({}, props, {
    className: 'icon',
    xmlns: 'http://www.w3.org/2000/svg',
    height: '24',
    viewBox: '0 0 24 24',
    width: '24'
  }), _react2.default.createElement('path', {
    d: 'M17.81 4.47c-.08 0-.16-.02-.23-.06C15.66 3.42 14 3 12.01 3c-1.98 0-3.86.47-5.57 1.41-.24.13-.54.04-.68-.2-.13-.24-.04-.55.2-.68C7.82 2.52 9.86 2 12.01 2c2.13 0 3.99.47 6.03 1.52.25.13.34.43.21.67-.09.18-.26.28-.44.28zM3.5 9.72c-.1 0-.2-.03-.29-.09-.23-.16-.28-.47-.12-.7.99-1.4 2.25-2.5 3.75-3.27C9.98 4.04 14 4.03 17.15 5.65c1.5.77 2.76 1.86 3.75 3.25.16.22.11.54-.12.7-.23.16-.54.11-.7-.12-.9-1.26-2.04-2.25-3.39-2.94-2.87-1.47-6.54-1.47-9.4.01-1.36.7-2.5 1.7-3.4 2.96-.08.14-.23.21-.39.21zm6.25 12.07c-.13 0-.26-.05-.35-.15-.87-.87-1.34-1.43-2.01-2.64-.69-1.23-1.05-2.73-1.05-4.34 0-2.97 2.54-5.39 5.66-5.39s5.66 2.42 5.66 5.39c0 .28-.22.5-.5.5s-.5-.22-.5-.5c0-2.42-2.09-4.39-4.66-4.39s-4.66 1.97-4.66 4.39c0 1.44.32 2.77.93 3.85.64 1.15 1.08 1.64 1.85 2.42.19.2.19.51 0 .71-.11.1-.24.15-.37.15zm7.17-1.85c-1.19 0-2.24-.3-3.1-.89-1.49-1.01-2.38-2.65-2.38-4.39 0-.28.22-.5.5-.5s.5.22.5.5c0 1.41.72 2.74 1.94 3.56.71.48 1.54.71 2.54.71.24 0 .64-.03 1.04-.1.27-.05.53.13.58.41.05.27-.13.53-.41.58-.57.11-1.07.12-1.21.12zM14.91 22c-.04 0-.09-.01-.13-.02-1.59-.44-2.63-1.03-3.72-2.1-1.4-1.39-2.17-3.24-2.17-5.22 0-1.62 1.38-2.94 3.08-2.94s3.08 1.32 3.08 2.94c0 1.07.93 1.94 2.08 1.94s2.08-.87 2.08-1.94c0-3.77-3.25-6.83-7.25-6.83-2.84 0-5.44 1.58-6.61 4.03-.39.81-.59 1.76-.59 2.8 0 .78.07 2.01.67 3.61.1.26-.03.55-.29.64-.26.1-.55-.04-.64-.29-.49-1.31-.73-2.61-.73-3.96 0-1.2.23-2.29.68-3.24 1.33-2.79 4.28-4.6 7.51-4.6 4.55 0 8.25 3.51 8.25 7.83 0 1.62-1.38 2.94-3.08 2.94s-3.08-1.32-3.08-2.94c0-1.07-.93-1.94-2.08-1.94s-2.08.87-2.08 1.94c0 1.71.66 3.31 1.87 4.51.95.94 1.86 1.46 3.27 1.85.27.07.42.35.35.61-.05.23-.26.38-.47.38z'
  }));
};

var PlusIcon = exports.PlusIcon = function PlusIcon(props) {
  return _react2.default.createElement(SVG, _extends({}, props, {
    className: 'icon',
    xmlns: 'http://www.w3.org/2000/svg',
    height: '24',
    viewBox: '0 0 24 24',
    width: '24'
  }), _react2.default.createElement('path', {
    d: 'M18 13h-5v5c0 .55-.45 1-1 1s-1-.45-1-1v-5H6c-.55 0-1-.45-1-1s.45-1 1-1h5V6c0-.55.45-1 1-1s1 .45 1 1v5h5c.55 0 1 .45 1 1s-.45 1-1 1z'
  }));
};

var SearchIcon = exports.SearchIcon = function SearchIcon(props) {
  return _react2.default.createElement(SVG, _extends({}, props, {
    className: 'icon',
    xmlns: 'http://www.w3.org/2000/svg',
    height: '24',
    viewBox: '0 0 24 24',
    width: '24'
  }), _react2.default.createElement('path', {
    d: 'M15.5 14h-.79l-.28-.27c1.2-1.4 1.82-3.31 1.48-5.34-.47-2.78-2.79-5-5.59-5.34-4.23-.52-7.79 3.04-7.27 7.27.34 2.8 2.56 5.12 5.34 5.59 2.03.34 3.94-.28 5.34-1.48l.27.28v.79l4.25 4.25c.41.41 1.08.41 1.49 0 .41-.41.41-1.08 0-1.49L15.5 14zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z'
  }));
};

var PaletteIcon = exports.PaletteIcon = function PaletteIcon(props) {
  return _react2.default.createElement(SVG, _extends({}, props, {
    className: 'icon',
    xmlns: 'http://www.w3.org/2000/svg',
    height: '24',
    viewBox: '0 0 24 24',
    width: '24'
  }), _react2.default.createElement('path', {
    d: 'M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16c2.76 0 5-2.24 5-5 0-4.42-4.03-8-9-8zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12zm3-4C8.67 8 8 7.33 8 6.5S8.67 5 9.5 5s1.5.67 1.5 1.5S10.33 8 9.5 8zm5 0c-.83 0-1.5-.67-1.5-1.5S13.67 5 14.5 5s1.5.67 1.5 1.5S15.33 8 14.5 8zm3 4c-.83 0-1.5-.67-1.5-1.5S16.67 9 17.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z'
  }));
};

var PeopleIcon = exports.PeopleIcon = function PeopleIcon(props) {
  return _react2.default.createElement(SVG, _extends({}, props, {
    className: 'icon',
    xmlns: 'http://www.w3.org/2000/svg',
    height: '24',
    viewBox: '0 0 24 24',
    width: '24'
  }), _react2.default.createElement('path', {
    d: 'M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V18c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-1.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05.02.01.03.03.04.04 1.14.83 1.93 1.94 1.93 3.41V18c0 .35-.07.69-.18 1H22c.55 0 1-.45 1-1v-1.5c0-2.33-4.67-3.5-7-3.5z'
  }));
};

var JobIcon = exports.JobIcon = function JobIcon(props) {
  return _react2.default.createElement(SVG, _extends({}, props, {
    className: 'icon',
    xmlns: 'http://www.w3.org/2000/svg',
    height: '24',
    viewBox: '0 0 24 24',
    width: '24'
  }), _react2.default.createElement('path', {
    d: 'M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z'
  }));
};

var LocationIcon = exports.LocationIcon = function LocationIcon(props) {
  return _react2.default.createElement(SVG, _extends({}, props, {
    xmlns: 'http://www.w3.org/2000/svg',
    height: '24',
    viewBox: '0 0 24 24',
    width: '24'
  }), _react2.default.createElement('path', {
    d: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z'
  }));
};

var EditIcon = exports.EditIcon = function EditIcon(props) {
  return _react2.default.createElement(SVG, _extends({}, props, {
    xmlns: 'http://www.w3.org/2000/svg',
    height: '24',
    viewBox: '0 0 24 24',
    width: '24'
  }), _react2.default.createElement('path', {
    d: 'M3 17.46v3.04c0 .28.22.5.5.5h3.04c.13 0 .26-.05.35-.15L17.81 9.94l-3.75-3.75L3.15 17.1c-.1.1-.15.22-.15.36zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z'
  }));
};

var WarningIcon = exports.WarningIcon = function WarningIcon(props) {
  return _react2.default.createElement(SVG, _extends({}, props, {
    xmlns: 'http://www.w3.org/2000/svg',
    height: '24',
    viewBox: '0 0 24 24',
    width: '24'
  }), _react2.default.createElement('circle', {
    cx: '12',
    cy: '19',
    r: '2'
  }), _react2.default.createElement('path', {
    d: 'M12 3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2s2-.9 2-2V5c0-1.1-.9-2-2-2z'
  }));
};

var FlameIcon = exports.FlameIcon = function FlameIcon(props) {
  return _react2.default.createElement(SVG, _extends({}, props, {
    xmlns: 'http://www.w3.org/2000/svg',
    height: '24',
    viewBox: '0 0 24 24',
    width: '24'
  }), _react2.default.createElement('path', {
    d: 'M17.09 4.56c-.7-1.03-1.5-1.99-2.4-2.85-.35-.34-.94-.02-.84.46.19.94.39 2.18.39 3.29 0 2.06-1.35 3.73-3.41 3.73-1.54 0-2.8-.93-3.35-2.26-.1-.2-.14-.32-.2-.54-.11-.42-.66-.55-.9-.18-.18.27-.35.54-.51.83C4.68 9.08 4 11.46 4 14c0 4.42 3.58 8 8 8s8-3.58 8-8c0-3.49-1.08-6.73-2.91-9.44zM11.71 19c-1.78 0-3.22-1.4-3.22-3.14 0-1.62 1.05-2.76 2.81-3.12 1.47-.3 2.98-.93 4.03-1.92.28-.26.74-.14.82.23.23 1.02.35 2.08.35 3.15.01 2.65-2.14 4.8-4.79 4.8z'
  }));
};

var CalenderIcon = exports.CalenderIcon = function CalenderIcon(props) {
  return _react2.default.createElement(SVG, _extends({}, props, {
    xmlns: 'http://www.w3.org/2000/svg',
    height: '24',
    viewBox: '0 0 24 24',
    width: '24'
  }), _react2.default.createElement('path', {
    d: 'M19 3h-1V2c0-.55-.45-1-1-1s-1 .45-1 1v1H8V2c0-.55-.45-1-1-1s-1 .45-1 1v1H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 16H6c-.55 0-1-.45-1-1V8h14v10c0 .55-.45 1-1 1zM8 10h3c.55 0 1 .45 1 1v3c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1v-3c0-.55.45-1 1-1z'
  }));
};

var ShopIcon = exports.ShopIcon = function ShopIcon(props) {
  return _react2.default.createElement(SVG, _extends({}, props, {
    xmlns: 'http://www.w3.org/2000/svg',
    height: '24',
    viewBox: '0 0 24 24',
    width: '24'
  }), _react2.default.createElement('path', {
    d: 'M5 6h14c.55 0 1-.45 1-1s-.45-1-1-1H5c-.55 0-1 .45-1 1s.45 1 1 1zm15.16 1.8c-.09-.46-.5-.8-.98-.8H4.82c-.48 0-.89.34-.98.8l-1 5c-.12.62.35 1.2.98 1.2H4v5c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-5h4v5c0 .55.45 1 1 1s1-.45 1-1v-5h.18c.63 0 1.1-.58.98-1.2l-1-5zM12 18H6v-4h6v4z'
  }));
};

var InstagramIcon = exports.InstagramIcon = function InstagramIcon(props) {
  return _react2.default.createElement(SVG, _extends({}, props, {
    xmlns: 'http://www.w3.org/2000/svg',
    width: '24',
    height: '24',
    viewBox: '0 0 24 24'
  }), _react2.default.createElement('path', {
    d: 'M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z'
  }));
};

var TwitterIcon = exports.TwitterIcon = function TwitterIcon(props) {
  return _react2.default.createElement(SVG, _extends({}, props, {
    xmlns: 'http://www.w3.org/2000/svg',
    width: '24',
    height: '24',
    viewBox: '0 0 24 24'
  }), _react2.default.createElement('path', {
    d: 'M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z'
  }));
};

var FacebookIcon = exports.FacebookIcon = function FacebookIcon(props) {
  return _react2.default.createElement(SVG, _extends({}, props, {
    xmlns: 'http://www.w3.org/2000/svg',
    width: '24',
    height: '24',
    viewBox: '0 0 24 24'
  }), _react2.default.createElement('path', {
    d: 'M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z'
  }));
};

var StarIcon = exports.StarIcon = function StarIcon(props) {
  return _react2.default.createElement(SVG, _extends({}, props, {
    xmlns: 'http://www.w3.org/2000/svg',
    height: '24',
    viewBox: '0 0 24 24',
    width: '24'
  }), _react2.default.createElement('path', {
    d: 'M19.65 9.04l-4.84-.42-1.89-4.45c-.34-.81-1.5-.81-1.84 0L9.19 8.63l-4.83.41c-.88.07-1.24 1.17-.57 1.75l3.67 3.18-1.1 4.72c-.2.86.73 1.54 1.49 1.08l4.15-2.5 4.15 2.51c.76.46 1.69-.22 1.49-1.08l-1.1-4.73 3.67-3.18c.67-.58.32-1.68-.56-1.75zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z'
  }));
};